<div class="container-fluid">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-6">
        <table>
          <td style="vertical-align: middle;"><img src="assets/img/global/cargo.png" alt="" title="" width="42" height="42">
          </td>
          <td>
            <p
              [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
              CARGOS E SALÁRIOS</p>
            <p
              [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
              EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
          </td>
        </table>
      </div>
      <div class="col-6">
        <a type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="22" width="22">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-4'" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12 table-responsive">
        <table
          [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Salário base</th>
              <th scope="col">Escolaridade</th>
              <th scope="col">Regime Jurídico</th>
              <th scope="col">Provimento</th>
              <th scope="col">Atividade</th>
              <th scope="col">Vagas</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td>{{item.cargo.nome}}</td>
              <td>{{item.cargo.salario_base | number:'1.2-2'}}</td>
              <td>{{item.cargo.escolaridade}}</td>
              <td>{{item.cargo.regime_juridico}}</td>
              <td>{{item.cargo.provimento}}</td>
              <td>{{item.cargo.atividade}}</td>
              <td>{{item.vagas}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>
